

























































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { DropDownItem } from "@/services/DropDownItem";
import { Vehicle } from "@/services/Vehicle";
import { LubricationTable } from "@/services/LubricationTable";
import { Group } from "@/services/Group";
import { VehicleType } from "@/services/VehicleType";
import ProductDetail from "@/components/ProductDetail.vue";

@Component({
  components: {
    ProductDetail,
  },
})
export default class VehiclesDetails extends Vue {
  @Prop({ type: String, required: false })
  idVehicle;
  @Prop({ type: Array, required: true })
  dropDownItems: [];
  @Prop({ type: Boolean, required: true })
  addMode;
  @Prop({ type: Boolean, required: true })
  firstSearch;
  loading: boolean = false;
  optionsDropDown: any = {
    optionBuilders: new Array(),
    optionBrands: new Array(),
    optionGearboxTypes: new Array(),
    optionTractions: new Array(),
    optionProductions: new Array(),
  };
  vehicle = new Vehicle();
  vehicleTypeList = new Array();
  productSelected: any = {
    idProduct: "",
    code: "",
  };
  isSaveClicked: boolean = false;
  newDropDownItem = new DropDownItem();
  isBuilderAdd: boolean = false;
  isSaveDropDownClicked: boolean = false;
  showAddDropDownModal(isBuilderAdd: boolean) {
    this.newDropDownItem = new DropDownItem();
    this.isBuilderAdd = isBuilderAdd;
    this.$bvModal.show("add-dropDown-modal");
  }
  //
  async addNewDropDownItem() {
    this.isSaveDropDownClicked = false;
    if (this.newDropDownItem.itemText) {
      if (!this.isBuilderAdd) {
        this.newDropDownItem.idDropDownFather =
          this.vehicle.builder.idDropDownItem;
        this.newDropDownItem.codDropDownSource = "BRAND";
        await this.addDropDownItem(this.newDropDownItem, null);
        if (this.vehicle.builder)
          await this.getDropDownItemChild(this.vehicle.builder.idDropDownItem);
      } else {
        this.newDropDownItem.codDropDownSource = "BUILDER";
        await this.addDropDownItem(
          this.newDropDownItem,
          this.vehicle.idVehicleType
        );
        if (this.vehicle.idVehicleType)
          await this.getVehicleTypeChild(this.vehicle.idVehicleType);
      }

      this.$bvModal.hide("add-dropDown-modal");
    } else {
      this.isSaveDropDownClicked = true;
      General.showAlertDanger("Please enter text for this new field", this);
    }
  }
  //Se è un Builder non avrò un idFather
  //Se è un Brand avrò l'idFather == vehicle.builder.idDropDownItem
  async addDropDownItem(dropDownItem: DropDownItem, idVehicleType?: string) {
    if (idVehicleType)
      try {
        this.loading = true;
        await axios({
          method: "post",
          url: General.GetApiUrl(
            "/api/dropDownItem/AddDropDownItem?idVehicleType=" + idVehicleType
          ),
          data: {
            ItemText: dropDownItem.itemText,
            CodDropDownSource: dropDownItem.codDropDownSource,
            IdDropDownFather: dropDownItem.idDropDownFather,
          },
          withCredentials: true,
          responseType: "json",
        });
        General.showAlertSuccess("Value successfully added", this);
      } catch (error) {
        General.HandleError(error, this);
      } finally {
        this.loading = false;
      }
    else
      try {
        await axios({
          method: "post",
          url: General.GetApiUrl("/api/dropDownItem/AddDropDownItem"),
          data: {
            ItemText: dropDownItem.itemText,
            CodDropDownSource: dropDownItem.codDropDownSource,
            IdDropDownFather: dropDownItem.idDropDownFather,
          },
          withCredentials: true,
          responseType: "json",
        });
        General.showAlertSuccess("DropDownItem successfully added", this);
      } catch (error) {
        General.HandleError(error, this);
      } finally {
        this.loading = false;
      }
  }

  returnState(condiction: boolean, clickButton: boolean): boolean {
    if (clickButton) return condiction;
    else return null;

  }

  setProductSelectedToTable(value, lubTable) {
    lubTable.product = value;
    lubTable.idVehicle = this.vehicle.idVehicle;
  }

  openProductDetail(product) {
    this.productSelected.idProduct = product.idProduct;
    this.productSelected.code = product.code;
    this.$bvModal.show("product-detail-modal");
  }

  resetVehicleTypeChild() {
    if (this.vehicle.brand.idDropDownItem) {
      this.vehicle.brand.idDropDownItem = null;
      this.optionsDropDown.optionBrands.splice(0);
    }
    if (this.vehicle.builder.idDropDownItem) {
      this.vehicle.builder.idDropDownItem = null;
      this.optionsDropDown.optionBuilders.splice(0);
    }
  }

  getResultValue(result) {
    if (result.description != "" && result.description != null)
      return result.description;
    return " - ";
  }

  async getGroupByVehicleType(idVehicleType: string) {
    this.vehicle.lubricationTables.splice(0);
    try {
      let response = await axios.get<[Group]>(
        General.GetApiUrl(
          "/api/LubricationTable/GetGroupsByIdVehicleType?IdVehicleType=" +
            idVehicleType
        ),
        {
          withCredentials: true,
        }
      );
      if (response.data != null)
        this.vehicle.lubricationTables = this.mapGroupsIntoLubTables(
          response.data
        );
    } catch (error) {
      if (error.response.status == 404) {
        this.$fire({
          title: "Error",
          text: "No groups associated to vehicleType selected",
          type: "error",
        });
      }
    }
  }
  mapGroupsIntoLubTables(array: Array<Group> = []): LubricationTable[] {
    let app = this;
    let result = new Array<LubricationTable>();
    array.forEach(function (gr) {
      result.push(
        new LubricationTable(
          null,
          new Group(gr.idGroup, gr.groupCode, gr.description, null)
        )
      );
    });
    return result;
  }

  removeUnselectedItem(lubricationTables: LubricationTable[]) {
    let newArray = new Array();
    lubricationTables.forEach(function (lb) {
      if (lb.product != null)
        newArray.push({
          idLubricationTable: null,
          product: {
            description: lb.group.description,
            idProduct: lb.product.idProduct,
          },
          idVehicle: lb.idVehicle,
          group: {
            idGroup: lb.group.idGroup,
            description: lb.group.description,
            groupCode: lb.group.groupCode,
          },
          note: lb.note,
          qta: lb.qta,
        });
    });
    return newArray;
  }

  exists(item, array: any[]): boolean {
    return array.some(function (object: LubricationTable) {
      object.group.idGroup === item.idGroup;
    });
  }

  async getDropDownItemChild(idDropDownItem: string) {
    this.loading = true;
    try {
      let response = await axios.get<[DropDownItem]>(
        General.GetApiUrl(
          "/api/DropDownItem/GetDropDownChild?idDropDownItem=" + idDropDownItem
        ),
        {
          responseType: "json",
          withCredentials: true,
        }
      );
      this.optionsDropDown.optionBrands = this.setOptions(response.data);
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }
  async mounted() {
    this.loading = true;
    await this.getVehicleTypes();
    if (!this.addMode) {
      await this.getVehicleById(this.idVehicle);
      await this.getMergedLubricationTables(
        this.vehicle.idVehicle,
        this.vehicle.idVehicleType
      );
      await this.getVehicleTypeChild(this.vehicle.idVehicleType);
      await this.getDropDownItemChild(this.vehicle.builder.idDropDownItem);
      
    }
    this.loading = false;
    this.optionsDropDown.optionTractions = this.setOptions(
      this.dropDownItems.filter(
        (item: DropDownItem) => item.codDropDownSource == "TRACTION"
      )
    );
    this.optionsDropDown.optionGearBoxTypes = this.setOptions(
      this.dropDownItems.filter(
        (item: DropDownItem) => item.codDropDownSource == "GEARBOX_TYPE"
      )
    );
    this.optionsDropDown.optionFuels = this.setOptions(
      this.dropDownItems.filter(
        (item: DropDownItem) => item.codDropDownSource == "FUEL"
      )
    );
     this.optionsDropDown.optionProductions = this.setOptions(
      this.dropDownItems.filter(
        (item: DropDownItem) => item.codDropDownSource == "PRODUCTION"
      )
    );
  }

  async getVehicleById(idVehicle: string) {
    try {
      let response = await axios.get<Vehicle>(
        General.GetApiUrl(
          "/api/LubricationTable/GetVehicle?idVehicle=" + idVehicle
        ),
        {
          withCredentials: true,
        }
      );
      if (!response.data.lubricationTables)
        response.data.lubricationTables = new Array<LubricationTable>();
      this.vehicle = response.data;
      if (this.vehicle.fuel==null) this.vehicle.fuel = new DropDownItem();
      if (this.vehicle.traction==null) this.vehicle.traction = new DropDownItem();
      if (this.vehicle.gearBoxType==null) this.vehicle.gearBoxType = new DropDownItem();
      // if(response.data.dateLastInfoUpdate)
      //   this.vehicle.dateLastInfoUpdate = response.data.dateLastInfoUpdate.slice(0,response.data.dateLastInfoUpdate.indexOf("T"))
    } catch (error) {
      General.HandleError(error, this);
    }
  }

  async getVehicleTypeChild(idVehicleType: string) {
    this.loading = true;
    try {
      let response = await axios.get(
        General.GetApiUrl(
          "/api/DropDownItem/GetVehicleTypesChilds?idVehicleType=" +
            idVehicleType
        ),
        {
          responseType: "json",
          withCredentials: true,
        }
      );
      this.optionsDropDown.optionBuilders = this.setOptions(response.data);
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  setOptions(dropDownItems: DropDownItem[]) {
    let array: Array<any> = [];
   
    array.push({ value: null, text: "" });

   
    dropDownItems.forEach(function (el) {
      array.push({ value: el.idDropDownItem, text: el.itemText });
    });
    return array;
  }

  async getMergedLubricationTables(idVehicle: string, idVehicleType: string) {
    try {
      let response = await axios.get(
        General.GetApiUrl(
          "/Api/LubricationTable/GetMergedLubricationTables?idVehicle=" +
            idVehicle +
            "&idVehicleType=" +
            idVehicleType
        ),
        {
          withCredentials: true,
        }
      );
      if (response.data) this.vehicle.lubricationTables = response.data;
    } catch (error) {
      General.HandleError(error, this);
    }
  }

  async deleteLubricationTableById(idLubricationTable: String) {
    try {
      this.loading = true;
      await axios.post(
        General.GetApiUrl(
          "/api/LubricationTable/DeleteLubricationTable?idLubricationTable=" +
            idLubricationTable
        ),
        {
          withCredentials: true,
          responseType: "json",
        }
      );
      General.showAlertSuccess("lubricationTable successfully removed", this);
    } catch (ex) {
      General.HandleError(ex, this);
    } finally {
      this.loading = false;
    }
  }

  async addOrUpdate(vehicle: Vehicle) {
    this.isSaveClicked = true;

    if (
      !vehicle.builder.idDropDownItem ||
      !vehicle.brand.idDropDownItem ||
      !vehicle.idVehicleType ||      
      !vehicle.production.idDropDownItem ||
      !vehicle.model ||
      !vehicle.yearOfRegistration

    )
      General.showAlertDanger("Please check Required fields ", this);
    else {
      let arrayLubricationTable = new Array();
      arrayLubricationTable = this.removeUnselectedItem(
        vehicle.lubricationTables
      );
      if (this.addMode) await this.addVehicleDo(vehicle, arrayLubricationTable);
      else await this.updateVehicleDo(vehicle, arrayLubricationTable);
      this.isSaveClicked = false;
    }
  }

  async updateVehicleDo(vehicle: Vehicle, arrayLubTables: any[]) {
    General.confirm(
      "Do you want update vehicle with code:" + vehicle.vehicleCode + "?",
      this,
      async () => {
        await this.updateVehicle(vehicle, arrayLubTables);
        this.closeDetailModal();
        if (this.firstSearch) this.$emit("vehicles-Search");
      }
    );
  }

  async addVehicleDo(vehicle: Vehicle, arrayLubTables: any[]) {
    General.confirm("Do you want add this vehicle?", this, async () => {
      let result = await this.addVehicle(vehicle, arrayLubTables);
      if (result==true){
        this.closeAddModal();
        if (this.firstSearch) this.$emit("vehicles-Search");
      }
    });
  }

  async addVehicle(vehicle: Vehicle, arrayLubTables: any[]):Promise<boolean>{
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/AddVehicle"),
        data: {
          idVehicleType: vehicle.idVehicleType,
          idBrand: vehicle.brand.idDropDownItem,
          idBuilder: vehicle.builder.idDropDownItem,
          idFuel: vehicle.fuel.idDropDownItem,
          idTraction: vehicle.traction.idDropDownItem,
          idGearboxType: vehicle.gearBoxType.idDropDownItem,
          idProduction: vehicle.production.idDropDownItem,
          gearBoxModel: vehicle.gearBoxModel,
          model: vehicle.model,
          yearOfRegistration: vehicle.yearOfRegistration,
          displacement: vehicle.displacement,
          staging: vehicle.staging,
          motorType: vehicle.motorType,
          lubricationTables: arrayLubTables,
        },
        withCredentials: true,
        responseType: "json",
      });
      General.showAlertSuccess("Vehicle successfully added", this);
      return true;
  
    } catch (error) {
      General.HandleError(error, this);
      
    } finally {
      this.loading = false;
    }
    return false;
  }

  async deleteVehicleDo(vehicle: Vehicle) {
    General.confirm(
      "Do you want delete the vehicle:" + vehicle.vehicleCode + "?",
      this,
      async () => {
        await this.deleteVehicleById(vehicle.idVehicle);
        this.closeDetailModal();
        this.$router.push("/vehicles");
        this.$emit("vehicles-Search");
      }
    );
  }
  async deleteVehicleById(idVehicle: string) {
    try {
      this.loading = true;
      await axios.delete(
        General.GetApiUrl(
          "/api/lubricationTable/DeleteVehicle?idVehicle=" + idVehicle
        ),
        { withCredentials: true }
      );
      General.showAlertSuccess("vehicle successfully removed", this);
    } catch (ex) {
      General.HandleError(ex, this);
    } finally {
      this.loading = false;
    }
  }
  async updateVehicle(vehicle: Vehicle, arrayLubTables: any[]) {
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/lubricationTable/UpdateVehicle"),
        data: {
          idVehicle: vehicle.idVehicle,
          idVehicleType: vehicle.idVehicleType,
          idBrand: vehicle.brand.idDropDownItem,
          idBuilder: vehicle.builder.idDropDownItem,
          idFuel: vehicle.fuel.idDropDownItem,
          idTraction: vehicle.traction.idDropDownItem,
          idGearboxType: vehicle.gearBoxType.idDropDownItem,
          gearBoxModel: vehicle.gearBoxModel,
          model: vehicle.model,
          yearOfRegistration: vehicle.yearOfRegistration,
          displacement: vehicle.displacement,
          staging: vehicle.staging,
          motorType: vehicle.motorType,
          lubricationTables: arrayLubTables,
        },
        withCredentials: true,
        responseType: "json",
      });
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  closeDetailModal() {
    this.$bvModal.hide("vehicle-detail-modal");
  }
  closeAddModal() {
    this.$bvModal.hide("vehicle-add-modal");
  }

  async getVehicleTypes() {
    try {
      let response = await axios.get<VehicleType[]>(
        General.GetApiUrl("/api/lubricationTable/GetVehicleTypes"),
        {
          withCredentials: true,
          responseType: "json",
        }
      );
      this.setOptionVehiclesTypes(response.data);
    } catch (ex) {
      General.HandleError(ex, this);
    }
  }

  setOptionVehiclesTypes(vehicleType: VehicleType[]) {
    let array: Array<any> = [];
    vehicleType.forEach(function (el) {
      array.push({ value: el.idVehicleType, text: el.type });
    });
    this.vehicleTypeList = [...array];
  }

  canManageLubTable() {
    return General.CanManageLubTable();
  }
}
